<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.merkitse-osittain-maksetuksi-dialog.merkitse-maksetuksi' | translate | async }}
  </lemon-dialog-header>

  <form (ngSubmit)="lisaaMaksettuaSummaa()" novalidate style="margin: 30px">
    <div style="display: flex; flex-flow: row wrap; justify-content: center">
      <mat-form-field>
        <mat-label>{{ 'lasku.merkitse-osittain-maksetuksi-dialog.avoinna' | translate | async }}</mat-label>
        <input decimalNumberField matInput style="margin: 0 1vw" [formField]="lomake.avoinna" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'lasku.merkitse-osittain-maksetuksi-dialog.maksettu-maara' | translate | async }}</mat-label>
        <input decimalNumberField matInput style="margin: 0 1vw" #maksettuMaaraInput cdkFocusRegionstart [formField]="lomake.maksettuMaara" />
        <mat-error>{{ fieldErrors.maksettuMaara }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'lasku.merkitse-osittain-maksetuksi-dialog.avoimeksi-jaa' | translate | async }}</mat-label>
        <input decimalNumberField matInput style="margin: 0 1vw" [formField]="lomake.avoimeksijaa" />
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <!-- <button mat-button mat-dialog-close>{{'lasku.merkitse-osittain-maksetuksi-dialog.peruuta' | translate | async}}</button> -->
  <app-primary-button (click)="lisaaMaksettuaSummaa()" [disabled]="!lomake().valid()" actionId="Merkitse maksetuksi dialog: Merkitse maksetuksi">{{ 'lasku.merkitse-osittain-maksetuksi-dialog.merkitse' | translate | async }}</app-primary-button>
</mat-dialog-actions>
